import { useQuery } from "@tanstack/react-query";
import { pageVisibilityService, PageKey } from "@/services/pageVisibilityService";
import { PAGE_DEFAULT_ENABLED } from "@/config/pageRegistry";

const QUERY_KEY = ["page-visibility"];

export const usePageVisibility = () => {
  // No Realtime subscription here: this hook is mounted by the sidebar and page
  // gate on every page for every visitor, and a per-visitor WebSocket is not
  // worth it just to notice a rare admin toggle. A light poll plus refetch on
  // window focus keeps hidden pages promptly up to date.
  const { data } = useQuery({
    queryKey: QUERY_KEY,
    queryFn: () => pageVisibilityService.getAll(),
    staleTime: 30 * 1000,
    refetchInterval: 60 * 1000,
    refetchOnWindowFocus: true,
  });

  const map = new Map<string, boolean>((data ?? []).map((r) => [r.page_key, r.is_enabled]));

  const isEnabled = (key: PageKey): boolean => {
    // No row yet (or not fetched): fall back to the registry default so a page
    // can ship switched off while staying admin-toggleable.
    return map.get(key) ?? PAGE_DEFAULT_ENABLED[key] ?? true;
  };

  return { isEnabled, all: data ?? [] };
};
